import { render, staticRenderFns } from "./ItemFilterBlock.vue?vue&type=template&id=9d172bc2&scoped=true&lang=pug&"
import script from "./ItemFilterBlock.vue?vue&type=script&lang=js&"
export * from "./ItemFilterBlock.vue?vue&type=script&lang=js&"
import style0 from "./ItemFilterBlock.vue?vue&type=style&index=0&id=9d172bc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d172bc2",
  null
  
)

export default component.exports